import { ApplicationType } from '@thesavingsgroup/enums/ApplicationType';
import { isInEnum } from '@thesavingsgroup/utils/isInEnum';
import { isNonEmptyStringOrNumber } from '@thesavingsgroup/utils/isNonEmptyStringOrNumber';

import { getVehicleApplicationType } from '../../dashboardStore/functions/getVehicleApplicationType';
import { DashboardVehicle } from '../../dashboardStore/types/DashboardVehicle';
import { PurchaseType } from '../enums/PurchaseType';
import { SearchVehicle } from '../enums/SearchVehicle';
import { ApplyState } from '../types/ApplyState';
import { HydrateFromCanceledApplication } from '../types/HydrateFromCanceledApplication';
import { VehicleIdentifiers } from '../types/VehicleIdentifiers';

export const toApplyStateFromCanceledApplication = async (
  canceledApplication: HydrateFromCanceledApplication,
  fetchVehicleIdentifiers: (
    vehicle: DashboardVehicle,
  ) => Promise<VehicleIdentifiers>,
): Promise<Partial<ApplyState>> => {
  const { vehicle } = canceledApplication;
  const { make, model, trim, year } = await fetchVehicleIdentifiers(vehicle);

  const vehicleApplicationType = getVehicleApplicationType(vehicle);

  const isPurchaseType = isInEnum(vehicleApplicationType, PurchaseType);

  const applicationType = isPurchaseType
    ? ApplicationType.PURCHASE
    : vehicleApplicationType;

  const mileage = isNonEmptyStringOrNumber(vehicle.mileage)
    ? String(vehicle.mileage)
    : null;

  const payoffAmount = isNonEmptyStringOrNumber(vehicle.payoffAmount)
    ? String(vehicle.payoffAmount)
    : null;

  const purchasePrice = isNonEmptyStringOrNumber(vehicle.purchasePrice)
    ? String(vehicle.purchasePrice)
    : null;

  const purchaseType = isPurchaseType ? vehicleApplicationType : null;

  let searchVehicle: SearchVehicle;

  if (vehicle.vin) {
    searchVehicle = SearchVehicle.BY_VIN;
  } else if (vehicle.plate && vehicle.province) {
    searchVehicle = SearchVehicle.BY_LICENSE_PLATE;
  } else {
    searchVehicle = SearchVehicle.BY_MAKE_MODEL;
  }

  return {
    applicationType,
    make,
    mileage,
    model,
    payoffAmount,
    plate: vehicle.plate,
    purchasePrice,
    purchaseType,
    refinanceGoal: vehicle.application.refinanceGoal,
    searchVehicle,
    state: vehicle.province,
    trim,
    vehicleCondition: vehicle.application.vehicleCondition,
    vin: vehicle.vin,
    year,
  };
};
